module.exports = __webpack_public_path__ + "img/barva-zakladni_08_zluta.0f69559a.png";